
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-15281.65 16849.35 16.7 11.301"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Symbol 202 – 25"}},[_c('path',{attrs:{"d":"M-15275.792 16859.968h-2.588a2.526 2.526 0 0 1-2.62-2.588 2.442 2.442 0 0 1 2.524-2.4h.064v-.252a4.712 4.712 0 0 1 9.233-1.342h.032c2.173 0 3.546 1.342 3.546 3.195a3.252 3.252 0 0 1-3.258 3.419h-2.62z","data-name":"Path 3673","fill":"none","stroke":"#444","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"1.3","opacity":".64"}})])])
          )
        }
      }
    